import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 2fr 3fr 2fr 1fr',
    columnGap: 12,
    '& p': { color: theme.palette.text.secondary },
    alignItems: 'center',
    padding: '6px 12px 6px 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr 2fr 3fr 2fr 1fr'
    }
  }
}))
export default useStyles
